import { useGetAuthQuery } from "../features/api";

/**
 * @param permission 許可する権限
 * @returns 許可する権限がログインユーザの権限に含まれるかフラグ
 */

export const useHasAuthorityHook = (permission: string) => {
  //権限取得
  const { hasAuthority } = useGetAuthQuery(undefined, {
    selectFromResult: ({ data }) => ({
      hasAuthority: data?.permissions.includes(permission),
    }),
  });
  return hasAuthority;
};
